










































































































































import { Component, Ref, Vue } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import CampoDeCnpjOuCpf from '@/components/ui/CampoDeCnpjOuCpf.vue'
import { formatarCnpjOuCpf } from '@/shareds/formatadores'
import { AvaliacaoNps, AvaliacaoNpsConfigLoja, Venda } from '@/models'
import { FindVendaUseCase } from '@/usecases'
import { obterTotalDaVenda } from '@/shareds/venda-shareds'
import DialogoDeAvaliacaoNpsDoCliente from './DialogoDeAvaliacaoNpsDoCliente.vue'

@Component({
	components: {
		CampoDeCnpjOuCpf,
		DialogoDeAvaliacaoNpsDoCliente,
	},
})
export default class TelaDeAvaliacaoNpsDoCliente extends Vue {
	@Ref() dialogoDeAvaliacaoNpsDoCliente!: DialogoDeAvaliacaoNpsDoCliente
	carregando = false
	salvando = false
	erro: string | null = null
	autenticado = false
	cnpjCpfDoCliente = ''
	validando = false
	venda: Venda | null = null
	utilizarAvaliacaoNps = false
	avaliacaoNpsConfigLoja: AvaliacaoNpsConfigLoja[] | [] = []

	formatarDocumento = formatarCnpjOuCpf
	obterTotalDaVenda = obterTotalDaVenda

	findVendaUseCase = new FindVendaUseCase()

	get valorTotal() {
		if (!this.venda) return 0
		return obterTotalDaVenda(this.venda) || 0
	}

	get valorTotalFormatado() {
		return this.formatarValor(this.valorTotal)
	}

	async mounted() {
		const identificador = this.$route.params.identificador
		await this.carregarVenda(identificador)
	}

	async carregarVenda(identificador: string) {
		this.carregando = true
		this.erro = null
		try {
			this.venda = await this.findVendaUseCase.findByIdentificadorSimple(identificador)
			this.utilizarAvaliacaoNps = this.venda.pontoDeVenda && this.venda.pontoDeVenda.loja.configuracaoDaLoja 
				&& this.venda.pontoDeVenda.loja.configuracaoDaLoja.utilizarAvaliacaoNps ? true : false
				
			if (this.utilizarAvaliacaoNps && this.venda.pontoDeVenda){
				this.avaliacaoNpsConfigLoja = this.venda.pontoDeVenda.loja.avaliacaoNpsConfig
			}

		} catch (e: any) {
			this.erro =
				e?.message || 'Não foi possível carregar a venda. Tente novamente.'
			this.venda = null
		} finally {
			this.carregando = false
		}
	}

	formatarValor(valor: number) {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(valor || 0)
	}

	private formatarCnpjOuCpf(doc?: string | null) {
		return (doc || '').replace(/\D/g, '')
	}

	async validarDocumentoDoCliente() {
		if (!this.venda || !this.venda.cliente) {
			AlertModule.setError('Venda inválida.')
			return
		}

		const informado = this.formatarCnpjOuCpf(this.cnpjCpfDoCliente)
		const esperado = this.formatarCnpjOuCpf(this.venda.cliente.cnpjOuCpf)

		if (!informado) {
			AlertModule.setError('Informe o CPF ou CNPJ para continuar.')
			return
		}

		if (informado !== esperado) {
			return AlertModule.setError('O documento informado não confere com o cadastro desta venda.')
		}

		this.autenticado = true
	}

	get avaliacaoPendente() {
		return this.venda && (this.venda.avaliacaoNps?.status === 'Pendente' || this.venda.avaliacaoNps?.status === 'Enviado') && this.utilizarAvaliacaoNps
	}

	abrirDialogoAvaliacaoNpsDoCliente(){
		if (!this.venda || !this.venda.identificador || !this.venda.avaliacaoNps) {
			this.erro = ("Não foi possível realizar a avaliação. Recarregue a página e tente novamente.")
			return
		}
		if (!this.avaliacaoNpsConfigLoja || !this.utilizarAvaliacaoNps) {
			this.erro = ("Loja está sem avaliação NPS configurada, contate o suporte.") 
			return
		}
		
		if (!this.venda.vendedor || this.venda.vendedor.length === 0) {
			this.erro = ("Venda está sem vendedor, entre em contato com o suporte.")
			return
		}

		this.dialogoDeAvaliacaoNpsDoCliente.mostrar(this.venda.identificador, this.venda.avaliacaoNps, this.avaliacaoNpsConfigLoja, this.venda.vendedor[0].id)
	}

	onSalvarAvaliacaoNpsDoCliente(avaliacaoSalva: AvaliacaoNps){
		if (!this.venda || !this.venda.avaliacaoNps) return
		this.venda.avaliacaoNps = avaliacaoSalva
	}
}
